import { Terminal } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { UserMenu } from "@/components/UserMenu";
import { LanguageSelector } from "@/components/LanguageSelector";
import { useLocale } from "@/contexts/LocaleContext";

export function Header() {
  const { user } = useAuth();
  const { t } = useLocale();

  return (
    <header className="relative border-b border-border/30 bg-cyber-darker/50 backdrop-blur-xl z-40">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="relative">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center shadow-neon">
                <Terminal className="w-4 h-4 text-primary-foreground" />
              </div>
              <div className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-primary animate-pulse" />
            </div>
            <div>
              <h1 className="text-base font-bold text-gradient-cyber inline-block">{t("header.title")}</h1>
              <p className="text-xs text-muted-foreground leading-none">{t("header.subtitle")}</p>
            </div>
          </Link>

          <div className="flex items-center gap-3">
            <span className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-primary/10 text-primary rounded-full border border-primary/20">
              <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse" />
              {t("header.ai_powered")}
            </span>

            {user ? (
              <UserMenu />
            ) : (
              <div className="flex items-center gap-2">
                <LanguageSelector variant="full" />
                <Link
                  to="/auth"
                  className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium bg-gradient-to-r from-primary to-secondary text-primary-foreground rounded-lg hover:shadow-neon transition-all"
                >
                  {t("header.sign_in")}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
